<template>
  <div id="app" ref="app" :class="{'web': !isMobile, 'inner-pages': webNavCrumbs}">
    <template v-if="isMobile">
      <div class="app-container">
        <keep-alive>
          <router-view
              :key="$route.fullPath"
              v-if="$route.meta.keepAlive"
              class="center"
              style="height: 100%;"
              @setUpdateNav='updateNavTitle'
          ></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"
                     class="center"
                     style="height: 100%;"
                     @setUpdateNav='updateNavTitle'></router-view>
      </div>
    </template>
    <template v-else-if="shaLongVisible">
      <div class="sha-long-wrapper">请在微信上打开本链接！</div>
    </template>
    <template v-else>
      <div class="nav-container web nav-container-pc" style="font-size: 13px" v-if="$route.path === '/login'">
        <div style="width: 1100px; margin: 0 calc(50vw - 600px);position: relative;">
          <div class="web-logo-box">&nbsp;</div>
        </div>
      </div>
      <div
          class="web"
          :class="{'web-login-bg': $route.path.indexOf('login') > 0}"
          :style="styleOfWeb"
          @scroll="loadMore">
        <div :class="{'hill-login-bg': $route.path.indexOf('login') > 0}"></div>
        <web-nav v-show="webNavCrumbs"></web-nav>
        <div class="web-app">
          <div
              v-if="webNavCrumbs"
              style="background-color: #F6F6F6;position: relative;z-index: 1;overflow: hidden">
            <div style="margin: 8px calc(50vw - 550px); display: flex; align-items: center; font-size: 18px;">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="title in breadNavTitle"
                                    @click.native="goParentPage(title.path)"
                                    style="cursor: pointer;font-size: 18px;line-height: 25px;margin: 8px 0 !important;">
                  {{ title.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-for="title in navParentWebTitleCustom"
                                    @click.native="goParentPage(title.path)"
                                    style="cursor: pointer;font-size: 18px;line-height: 25px;margin: 8px 0 !important;">
                  {{ title.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item style="font-size: 18px;line-height: 25px;margin: 8px 0 !important;">
                  {{ navWebTitle }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="app-container" :style="styleOfAppContainer">
            <keep-alive>
              <router-view
                  v-if="$route.meta.keepAlive"
                  class="center"
                  :updateData="updateData"
                  @setUpdateNav='updateNavTitle'
              ></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"
                         class="center"
                         :updateData="updateData"
                         @setUpdateNav='updateNavTitle'></router-view>
          </div>
        </div>
      </div>
    </template>
    <xt-notice :visible.sync="$root.globalNotice.show" :content="$root.globalNotice.content"></xt-notice>
  </div>
</template>

<script>
import './css/common.css'
import './css/index.less'
import webNav from './components/web-nav'
import {logout} from './service/login.js'
import {isIE, windowMatchMobile} from './util/index.js'
import XtNotice from "@/components/xtNotice";
import CusserWeb from '@/assets/icon_cusser_web.svg';
import GroupWeb from '@/assets/icon_group_web.svg';
import {webTracingInit} from "@/service/common";
import {Shares} from './util/Share'

export default {
  name: 'app',
  data() {
    return {
      screenHeight: '',
      updateData: false,
      hidshow: false,
      navTitle: '',
      navLeftTitle: '',
      navRightTitle: '',
      navMenu: false, // left icon
      myIcon: false,// right icon
      navWebTitleCustom: false,
      navParentWebTitleCustom: [],
      parentTitle: [],
      CusserWeb,
      GroupWeb,
      webNavCrumbs: false
    }
  },
  computed: {
    breadNavTitle() { // web
      return !this.$route.meta.parentTitle ? this.parentTitle : this.$route.meta.parentTitle
    },
    navWebTitle() {
      let $route = this.$route
      let pdfName = $route.query.report_name
      return this.navWebTitleCustom || pdfName || this.meta.navWebTitle
    },
    isMobile() {
      return this.$root.isMobile
    },
    customerName() {
      return this.$store.state.base.customerName
    },
    meta() {
      return this.$route.meta
    },
    noWebNav() {
      return this.meta.noWebNav
    },
    navLeftBox() {
      return this.meta.noBack
    },
    styleOfWeb() {
      let style = 'height:100%;'
      if (isIE()) {
        style += 'overflow:hidden;'
      } else {
        style += 'overflow-x:auto;overflow-y:auto;'
      }
      if (this.$route.path.indexOf('login') > 0) {
        style += 'background-color: #9a999e;'
      } else {
        style += 'background-color: #F6F6F6;'
      }
      return style
    },
    styleOfAppContainer() {
      let style = ''
      // IE浏览器不支持initial，可能会导致无法滑动
      if (isIE()) {
        style += 'overflow-y: auto;overflow-x: hidden;'
      } else {
        style += 'overflow: initial;'
      }
      // 没有左侧导航时，上方会添加面包屑，高度会更低
      if (this.noWebNav) {
        style += 'height:calc(100% - 57px);'
      } else {
        style += 'height:calc(100% - 30px);'
      }
      return style
    },
    shaLongVisible() {
      /** 沙龙问卷不允许在 PC 上使用 显示  “请在微信上打开本链接”  */
      return (this.$route.path.indexOf('managerRiskQuestion') > -1
          || this.$route.path.indexOf('personFillCustomerInfo') > -1
          || this.$route.path.indexOf('institutionFillAgentInfo') > -1
          || this.$route.path.indexOf('institutionFillInfo') > -1
          || this.$route.path.indexOf('potentialConfirmPage') > -1
          || this.$route.path.indexOf('submitSuccess') > -1
      ) && !windowMatchMobile()
    }
  },
  components: {
    XtNotice,
    webNav
  },
  methods: {
    pushToLogin() {
      this.$router.push('/login')
    },
    loadMore(e) {
      let tar = e.target
      // console.log(tar.scrollHeight - tar.clientHeight - tar.scrollTop < 20)
      if (tar.scrollHeight - tar.clientHeight - tar.scrollTop < 20) {
        this.updateData = true
      } else {
        this.updateData = false
      }
    },
    goParentPage(path) { // web
      for (let i = window.stateArray.length - 1; i > 0; i--) {
        if (window.stateArray[i].path === path) {
          this.$router.push({path: window.stateArray[i].fullPath})
          return
        }
      }
      this.$router.push({path})
    },
    async logoutHandler() {
      await logout()
      this.$store.state.base.userId = null
      this.$router.replace({path: '/login'})
      this.$router.go(0)
    },
    updatedNav(to, from) {
      let meta
      if (to) {
        meta = to.meta
      } else {
        meta = this.$route.meta
      }
      document.title = meta.weChatTitle || '高毅资产客户服务';
      if (meta.navTitle) {
        this.$store.commit('updateNavTitle', meta.navTitle)
        this.navTitle = meta.navTitle
      }
      if (meta.leftIcon) {
        this.navMenu = true
      } else {
        this.navMenu = false
      }
      if (meta.rightIcon) {
        this.myIcon = true
      } else {
        this.myIcon = false
      }
      if (this.isMobile) {
        return
      }
      if (from && to) {
        let arr = ['fundIntroductionWeb','ePdf', 'pdfWeb', 'history-application', 'application-detail_web', 'pdfWeb',
          'imageVideoMp3View4', 'fundAndReportMsgPdfWeb4', 'fundAndReportMsgPdfWeb5', 'managerRiskQuestion', 'contractFile']
        let flag = false
        for (let i = 0; i < arr.length; i++) {
          if (to.fullPath.indexOf(arr[i]) > 0) {
            console.log('to.fullPath', to.fullPath)
            flag = true
          }
        }
        if (flag) {
          if (to.meta.parentTitle) {
            if (from.fullPath.indexOf('productDetail') > 0 && to.fullPath !== '/history-application') {
              to.meta.parentTitle[0].name = '产品详情'
              to.meta.parentTitle[0].path = '/myAttentionTab'
            } else if (from.fullPath.indexOf('myPropertiesTab') > 0 && to.fullPath !== '/history-application') {
              to.meta.parentTitle[0].name = '我的资产'
              to.meta.parentTitle[0].path = '/myPropertiesTab'
            }
            if (to.query.name && to.query.path) {
              if (to.meta.parentTitle.length === 1) {
                to.meta.parentTitle.push({name: '', path: ''})
              }
              to.meta.parentTitle = to.meta.parentTitle.slice(0, 2)
              to.meta.parentTitle[1].name = to.query.name
              to.meta.parentTitle[1].path = to.query.path
            } else {
              to.meta.parentTitle.splice(1)
               // 该规则只用在推介材料跳转pdf页
              if (this.$route.query.customized) {
                to.meta.parentTitle = JSON.parse(localStorage.getItem('parentTitle'))
              }
            }
          }
          }

      }

    },
    updateNavWebTitle(navWebTitle) {
      this.navWebTitleCustom = navWebTitle
    },
    pushParentTitle(parentTitle) {
      this.navParentWebTitleCustom.push(parentTitle)
    },
    updateNavTitle(obj) {
      let {navTitle} = obj
      this.$store.commit('updateNavTitle', navTitle)
      this.navTitle = navTitle
    },
    pushHistory() {
      let state = {
        title: 'title',
        url: ''
      }
      window.history.pushState(state, 'title', '')
    },
    async onRefresh() {
      // 刷新后返回首页
      if (this.isMobile) {
        const array = [
          '/wechat/redirect', '/wechat', '/myPropertiesTab', '/myAttentionTab',
          '/personalData', '/reportsNoBack', '/historyTabNoBack', '/agreementPage', '/agreementDialogPage', '/quicklyRegister',
          '/myAllFundAndReportMessageNoBack', '/imageVideoMp3View', '/directImageVideoMp3View', '/directFundAndReportMsgPdfWeb', '/wechatFollowed',
          '/personFillCustomerInfo' ,'/institutionFillAgentInfo', '/institutionFillInfo', '/potentialConfirmPage','/submitSuccess',
          '/managerRiskQuestion', '/managerRiskQuestion/suitability', '/managerRiskQuestion/ofType', "/managerRiskQuestion/result", "/managerRiskQuestion/resultComplete",'/recordComplete','/faceVerifyOne', '/signContractSuccess', '/reservationSuccess', '/pdfjs', '/application-detail', '/makePayment', '/pdfRecord', '/contractPreview'
        ]
        for (let i in array) {
          if (array[i] === window.location.pathname) {
            return
          }
        }
        const redirectUrl = localStorage.getItem('wechatUrl1')

        if (redirectUrl && redirectUrl !== 'undefined') {
          this.$router.push({path: redirectUrl})
          return
        }
        this.$router.push({path: '/myPropertiesTab'})
      }
    },
    async goBackAndClearAfter(path) {
      for (let i = window.stateArray.length - 1; i >= 0; i--) {
        if (window.stateArray[i].fullPath === path) {
          window.stateArray.splice(i + 1)
          break
        }
      }
      await this.$router.push({path})
    },
    async goBack() {
      let route = this.$route
      // 禁止回退
      if (['myPropertiesTab'].includes(route.name)) {
        window.history.replaceState({}, '', window.location.href)
        location.reload();
      }
      let query = route.query
      let clearRollback = route.meta.clearRollback || query.clearRollback;
      // 清空回退跳转
      if (clearRollback) {
        // 退回详情页面的时候需要手动加上applyId
        if (clearRollback.includes('application-detail')) {
          if (!clearRollback.includes('?')) {
            const {
              apply_id,
            } = this.$store.state.base.reservationData;
            if (!apply_id) return;
            clearRollback = `${clearRollback}?applyId=${apply_id}`
          }
        }
        let url = clearRollback;
        if (url.includes('?')) {
          url = `${url}&clearRollback=${clearRollback}`
        } else {
          url = `${url}?clearRollback=${clearRollback}`
        }
        // // window.location.replace(url);
        window.history.replaceState({}, '', url)
        return;
      }
      const array = ['/myPropertiesTab', '/on-passage-application', '/myAttentionTab', '/historyTab', '/reports', '/personalData']
      if (!this.isMobile) {
        let goNext = true
        array.forEach((item) => {
          if (route.fullPath === item) {
            goNext = false
          }
        })
        if (!goNext) {
          this.pushHistory()
          return
        }
      }
      let goBack = route.meta.goBack
      if (query.disableGoBack) {
        window.history.replaceState({}, '', route.fullPath+ '&disableGoBack=true')
        return
      }
      this.$store.commit('updateNavTitle', this.$route.meta.navTitle)
      if (this.navLeftBox) {
        this.pushHistory()
        return
      }
      if (this.$root.goBackFunc !== null && typeof this.$root.goBackFunc === 'function') {
        this.$root.goBackFunc()
        this.pushHistory()
        this.$root.goBackFunc = null
        return
      }
      window.goBack = true
      this.$root.globalNotice.show = false
      if (query.goBack) {
        await this.goBackAndClearAfter(query.goBack)
      } else if (goBack) {
        await this.goBackAndClearAfter(goBack)
      } else {
        let path = window.stateArray.splice(window.stateArray.length - 1)
        this.$router.push(window.stateArray[window.stateArray.length - 1])
      }
    },
    disableBack() {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', function(event) {
        // 阻止默认行为
        event.preventDefault();
        event.stopPropagation();

        // 重新设置当前页面的历史记录
        window.history.pushState(null, '', window.location.href);
      });
    },
    goPersonalData() {
      this.myIcon = false
      this.$router.push({path: '/personalData'})
    }
  },
  created() {
    let _this = this
    console.log('======cals===========')
    window.addEventListener('popstate', function (e) {
      _this.goBack()
    })
    this.onRefresh()
  },
  mounted() {
    this.updatedNav()
    Shares.initRealAuthUrl()
    webTracingInit(this.$store.state.base.userId)
  },
  watch: {
    $route(to, from) {
      this.navWebTitleCustom = ''
      this.navParentWebTitleCustom = []
      let path = to.path
      //todo 一下菜单 不显示 顶部 菜单切换tab
      this.webNavCrumbs = path.indexOf('login') < 0 && path.indexOf('register') < 0 && path.indexOf('findPassword') < 0 &&
          path.indexOf('agreementPage') < 0 && path.indexOf('agreementDialogPage') < 0 && path.indexOf('quicklyRegister') < 0 && path.indexOf('wechat') < 0 && path.indexOf('managerRiskQuestion') < 0 && path.indexOf('qualifiedInvestor') < 0
      this.updatedNav(to, from)
      this.$refs.app.scroll(0, 0)
    },
    navLeftBox: {
      handler(cur, old) {
        console.log('禁止点击返回按钮')
      }
    }
  },
  destroyed() {
    Shares.clearRealAuthUrl()
  }
}
</script>

<style lang="less" scoped>
@import './css/mobile.less';

#app {
  height: 100%;
  overflow: hidden;
  color: @text-color;

  &.web {
    overflow: auto;
  }

  &.web.inner-pages {
    overflow: auto;
  }
}

.web-app {
  min-height: calc(100vh - 126px);
}

.nav-container {
  height: 38px;

  .nav-left-box {
    height: 38px;
    background-size: 22px;
    background-repeat: no-repeat;
    background-position: 30% center;
    display: flex;
    align-items: center;
  }

  .nav-right-box {
    display: flex;
    align-items: center;
  }


  .nav-left-icon {
    /*
     * 这版不做导航左侧菜单按钮, 暂时去掉
     * background-image: url('./assets/menu.svg');
    */
    background-image: url('./assets/menu.svg');
  }

  .back {
    background-image: url('./assets/back.svg');
  }

  .nav-right-icon {
    height: 44px;
    /*
     * 这版不做导航右侧我的按钮, 暂时去掉
     * background-image: url('./assets/myCenter.svg');
    */
    background-image: url('./assets/myCenter.svg');
    background-size: 22px;
    background-repeat: no-repeat;
    background-position: 70% center;
  }
}

.nav-container-pc {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
}


.app-container {
  position: absolute;
  /*height: ~"calc(100% - 44px)";*/
  height: 100%;
  min-height: 400px;
  overflow: hidden;
  width: 100%;
}

.logo-img {
  width: 88px;
  height: 28px;
  margin-top: 9px;
}

.sha-long-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  padding: 180px 0;
}
</style>
<style lang="less">
//  element-ui的el-select在ios移动端需要点击两次的兼容适配 start
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
// 验证码缩放
// .tcaptcha-transform{
// transform: scale(0.8);
// }

//  element-ui的el-select在ios移动端需要点击两次的兼容适配 end
.electron-message {
  min-width: 94%;
  box-sizing: border-box;
  padding: 15px 10px;
  border-radius: 4px;
  border-left: 4px solid #49bb11;
  background: #fff;

  .el-message__icon {
    color: #49bb11;

  }

  .el-message__content {
    font-size: 12px;
    font-weight: bold;
    color: #333333;
    padding-right: 24px !important;

    .introduction {
      margin-top: 10px;
      color: #a1a1a1;
      font-weight: normal;
      line-height: 14px;
    }
  }
}

.electron-message-pc {
  background-color: rgb(240, 249, 235);
  border-color: rgb(225, 243, 216);
  
  .el-message__icon,
  .el-message__content {
    color: #49bb11;
  }
}

.electron-message-warning {
  width: max-content;
  min-width: auto;
  max-width: calc(100% - 40px);
  box-sizing: border-box;
}

.mint-indicator-mask {
  z-index: 99999;
}
.mint-indicator-text {
  white-space: pre-wrap;
}

.crm-dialog-pc,
.crm-dialog-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .el-dialog {
    margin: 0 !important; 
    border-radius: 12px;
    overflow: hidden;
    background: none;

    .el-dialog__header {
      height: auto;
      padding: 16px 20px;
      background: #4e82cb;
      line-height: initial;
      display: flex;
      justify-content: space-between;

      .el-dialog__title {
        color: #fff;
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
      }

      .el-dialog__headerbtn {
        height: 18px;
        position: inherit;

        .el-dialog__close {
          color: #fff;

          &:hover {
            color: #fff;
          }
        }
      }
    }

    .el-dialog__body {
      background: #fff;
      padding: 20px;
      line-height: 1.8;
      max-height: calc(100vh - 120px);
      overflow-x: hidden;
      overflow-y: auto;
    }

    .el-dialog__footer {
      background: #fff;
      padding: 0 20px 20px;
      display: flex;
      justify-content: right;

      & > .el-button {
        width: 50%;
      }

      .el-button {
        padding: 10px 18px;

        &:focus, &:hover {
          color: #606266;
          background: #fff;
          border-color: #dcdfe6;
        }
      }

      .el-button--primary {
        &:focus, &:hover {
          color: #fff;
          background: #4C7EC5;
          border-color: #4C7EC5;
        }
      }

      .is-disabled {
        border-color: #b0c9eb;
        background: #b0c9eb;

        &:focus, &:hover {
          color: #fff;
          background: #b0c9eb;
          border-color: #b0c9eb;
        }
      }
    }
  }
  // .el-button--default {
  //   &:focus, &:hover {
  //     background: inherit;
  //     border-color: #4C7EC5;
  //     color: #4C7EC5;
  //   }
  // }
}
.crm-dialog-mobile {
  .el-dialog {
    width: calc(100vw - 40px) !important;
    
    .el-dialog__header {
      .el-dialog__title {
        font-size: 17px;
      }
    }

    .el-dialog__footer {
      justify-content: space-between;

      .el-button {
        width: calc(50% - 6px);
        padding: 10px 0;
      }
      .el-button + .el-button {
        margin-left: 0;
      }
    }
  }
}
</style>
